module.exports = __webpack_public_path__ + "static/media/CHAP03-PHOTO-IEM.753fc968.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img/CHAP03-PHOTO-IEM.png
// module id = 286
// module chunks = 0